import { Box,Button,Flex,Select,InputGroup,
    InputLeftElement,Input, Text, 
    TableContainer,Table,Thead,Tbody,Th,Tr,Td,Grid,GridItem,Textarea} from "@chakra-ui/react";
  import { TopDisplay } from "../../../../components";
  import { IoMdAdd as AddIcon } from "react-icons/io";
  import { LuSearch as SearchIcon } from "react-icons/lu";
  import { useState , useEffect} from "react";
  import { useMutation, useQuery, useQueryClient } from 'react-query';
  import styled from "@emotion/styled";
  import { atom, useAtom } from 'jotai';
  import apiCall from '../../../../utils/apiCall';
  import {TopLink} from '../';
  import {openAtom,modalAtom,openNAtom,notificationAtom} from '../../../../context';
  import { Formik,Form,Field } from "formik";
  import {TablePopUp} from '../../../../components';
  import * as Yup from 'yup';
  import { format } from "date-fns";
  import { Loader } from "../../../../customs";
  import { TbReload as ReloadIcon } from "react-icons/tb";
import ReactPaginate from 'react-paginate';


  // const allSuspend = [
  //   {
  //     Id:Math.floor(Math.random() * 10000)+1,
  //     ExamId:'12345',
  //     SubjectName:'Internet of things',
  //     Level:'2',
  //     CutOffMark: '50',
  //     Amount:'300,000'
  //   },
  //   {
  //     Id:Math.floor(Math.random() * 10000)+1,
  //     ExamId:'12345',
  //     SubjectName:'Internet of things',
  //     Level:'2',
  //     CutOffMark: '50',
  //     Amount:'300,000'
  //   },
  //   {
  //     Id:Math.floor(Math.random() * 10000)+1,
  //     ExamId:'12345',
  //     SubjectName:'Internet of things',
  //     Level:'2',
  //     CutOffMark: '50',
  //     Amount:'300,000'
  //   } ,
  //   {
  //     Id:Math.floor(Math.random() * 10000)+1,
  //     ExamId:'12345',
  //     SubjectName:'Internet of things',
  //     Level:'2',
  //     CutOffMark: '50',
  //     Amount:'300,000'
  //   },
  //   {
  //     Id:Math.floor(Math.random() * 10000)+1,
  //     ExamId:'12345',
  //     SubjectName:'Internet of things',
  //     Level:'2',
  //     CutOffMark: '50',
  //     Amount:'300,000'
  //   }  
  // ]
  
  const HeadStyle={
    borderBottom:"1px solid var(--dark-green-color)",
    padding:'15px 5px',
  }
  const DataStyle = {
    padding:'5px 5px',
  }
  
  
  const ROWSTYLE = styled.tr`
    & > td:last-of-type > *{
      display:none;
    }
    :hover > td{
      background-color:var(--table-highlight);
      &:last-of-type > *{
        display:block;
      }
    } 
    &.active > td:last-of-type > *{
      display:block !important;
    }  
  `
  
  const SuspendAtom = atom<number | null>(null);
  
  
  export default function Suspend() {
    const [hide,set_hide] = useState<boolean>(true);
    const [,set_modal] = useAtom(modalAtom);
    const [,set_open] = useAtom(openAtom);
    const [active] = useAtom<number | string | null>(SuspendAtom);

    const {isLoading,data:all_Suspend} = useQuery(['suspend-student'],{
      queryFn:async ()=> await apiCall().get(`/Exam/students/suspended`),
      select(data){
        return data.data.Data;
      }
    })
    const [search,set_search] = useState('');
    const [filter_data,set_filter_data] = useState<any>(all_Suspend);

    const handleAddSuspend = () =>{
      set_modal({
        header:'Suspend Student',
        content:<AddType />
      })
      set_open(true);
  }
  const handleSearch = (e:any)=>{
    let val = e.target.value;
    set_search(val);
    if(val){
      let new_data = filter_data?.filter((eData:any) => Object.values(eData).join('').toLowerCase().includes(val.toLowerCase()) );
      if(new_data.length > 0)set_filter_data(new_data)
      else set_filter_data(all_Suspend)
    }
    else set_filter_data(all_Suspend)
  }

  const itemsPerPage = 10;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  const currentItems = filter_data?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filter_data?.length / itemsPerPage);

  const handlePageClick = (event:any) => {
    const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
  };
  useEffect(()=>{
    set_filter_data(all_Suspend)
  },[all_Suspend])
  
    return (
      <> 
      {isLoading?<Loader />:
      <Box>
        <TopLink />
        <TopDisplay label="Suspend Student" button_array={[
            <Button onClick={handleAddSuspend} bg="var(--dark-green-color)" color="var(--white-color)"  type="button"  leftIcon={<AddIcon/>}>Suspend Student</Button>
          ]} />
          <Flex  gap="20px" wrap="wrap" mt="20px">
            <InputGroup width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
              <InputLeftElement pointerEvents='none'>
                <SearchIcon color='gray.300' />
              </InputLeftElement>
              <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
            <span style={{position:'absolute',zIndex:'1',
            right:'10px',cursor:'pointer',top:'12px'}}><ReloadIcon /></span>
            </InputGroup>
            {/* <Select placeholder="Status" width="150px" bg="var(--white-color)" 
              borderColor="var(dark-green-color)">
                 {allStatus && allstatus.length  > 0?
                 allstatus.map((eCountry:any) =>
                  <option key={pending}>{eCountry.CountryName}</option>
                 )
                :'' } 
            </Select> */}
            
  
          </Flex>
          <Flex mt="25px" flexDir="column" gap="10px">
          <Text m="0" fontSize="1rem">All Suspended Students</Text>
            <Text m="0" fontSize=".8rem">Showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
          </Flex>
       { filter_data && filter_data.length > 0 ? <TableContainer mt="20px">
            <Table size='sm'>
              <Thead>
                <Tr >
                  <Th sx={HeadStyle}>Student ID</Th>
                  <Th sx={HeadStyle}>Suspension start</Th>
                  <Th sx={HeadStyle}>Suspension End</Th>
                  <Th sx={HeadStyle}>Reason</Th>
                  <Th sx={HeadStyle}>IsSuspended</Th>
                  <Th sx={HeadStyle} w="50px"></Th>
                </Tr>
              </Thead>
              <Tbody>
                {currentItems.map((eSuspend:any) =><ROWSTYLE key={eSuspend.StudentMembershipNo} className={eSuspend.StudentMembershipNo === active?'active':''}>
                  <Td sx={DataStyle}>{eSuspend.StudentMembershipNo}</Td>
                  <Td sx={DataStyle}>{eSuspend.SuspensionStartDate ? format(new Date(eSuspend.SuspensionStartDate), "dd/MM/yyyy") : "N/A"}</Td> 
                  <Td sx={DataStyle}>{eSuspend.SuspensionStartDate ? format(new Date(eSuspend.SuspendedUntil), "dd/MM/yyyy") : "N/A"}</Td> 
                  <Td sx={DataStyle}>{eSuspend.Reason ||'N/A'}</Td>
                  <Td sx={DataStyle}>{eSuspend.IsSuspended?'Yes':'No'}</Td>
                  <Td sx={DataStyle} w="50px" h="50px">
                    <TempPopUp index={eSuspend.StudentMembershipNo} data={eSuspend}/>
                  </Td>
                </ROWSTYLE>
                )}
              </Tbody>
            </Table>
          </TableContainer>
          :'  No  Suspended student'  
        }
        <StylePaginateBox>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />

      </StylePaginateBox>
  
      </Box>
  }
      </>
     
    )
  }
  const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`
  
              const AddSchema = Yup.object({
                StudentMembershipNo:Yup.string().required(),
                Reason:Yup.string(),
                SuspensionStartDate:Yup.date().required(),
                SuspensionEndDate:Yup.date().required(),

              });
              const AddType = (props: any) => {
              const queryClient = useQueryClient();
              const [, set_open] = useAtom(openAtom);
              const [, set_Nopen] = useAtom(openNAtom);
              const [, set_notification] = useAtom(notificationAtom);
              const [Reason, set_reason] = useState(props?.Reason || '');
              const formatDate = (dateTime: string | number | Date) => {
                if (!dateTime) return ''; 
                const date = new Date(dateTime);
                return date.toISOString().split('T')[0]; // Extract only the date part
              };              
  
              const { mutate: addUpdate, isLoading } = useMutation({
                mutationKey: ['new-suspend-student'],
                mutationFn: async (data: any) => {
                  return props && props.Id
                    ? await apiCall().put(`/Exam/EditSuspendedStudent${props.Id}`, data)
                    : await apiCall().post(`/Exam/suspendStudent`, data);
                },
                onSuccess: (data) => {
                  const message = data?.data?.Message || 'Suspended Successfully';
                  const isNotificationIssue = message.includes("Email template for suspension notification not found");
              
                  set_notification({
                    type: isNotificationIssue ? 'warning' : 'success',
                    message: isNotificationIssue 
                      ? "Suspension successful, but the email notification could not be sent." 
                      : message,
                  });
                  set_Nopen(true);
              
                  // Refresh or invalidate queries if needed
                  queryClient.invalidateQueries({
                    queryKey: ['suspend-student'],
                  });
                },
                onError(error: any) {
                  set_notification({
                    type: 'error',
                    message: error?.response?.data?.Message || 'Error occurred during suspension',
                  });
                  set_Nopen(true);
                },
                onSettled: (data, error) => {
                  set_open(false);
                },
              });
    
  
    return (
      <Formik
          initialValues={{
            StudentMembershipNo: props.StudentMembershipNo || '',
            Reason: props.Reason || '',
            SuspensionStartDate: props.SuspensionStartDate || '',
            SuspensionEndDate: props.SuspensionEndDate || '',  // Corrected here
          }}
          validationSchema={AddSchema}
          onSubmit={(values: any) => {
            const data = {
              StudentMembershipNo: values.StudentMembershipNo,
              Reason,
              SuspensionStartDate: values.SuspensionStartDate,
              SuspensionEndDate: values.SuspensionEndDate,
            };
            addUpdate(data);
          }}
        >
        {(formik: any) => {
          const { errors, values } = formik;
          function setFieldValue(arg0: string, value: string): void {
            throw new Error("Function not implemented.");
          }

          return (
            <Form>
              <Flex flexDir="column" align="center" gap="20px">
                <Flex w="100%" as="label" flexDir="column" gap="10px">
                  <Text fontWeight="bold">Student Membership No:</Text>
                  <Input
                    as={Field}
                    size="md"
                    borderColor="#437115y689"
                    placeholder="StudentMembershipNo"
                    name="StudentMembershipNo"
                    type="text"
                  />
                </Flex>
                <Flex w="100%" as="label" flexDir="column" gap="10px">
                  <Text fontWeight="bold">Suspension Start Date:</Text>
                  <Input
                as={Field}
                size="md"
                borderColor="#437115"
                placeholder="Choose suspension start date"
                name="SuspensionStartDate"
                type="date"
                value={formatDate(values.SuspensionStartDate)} // Format the value
                onChange={(e) => setFieldValue('SuspensionStartDate', e.target.value)} // Update value on change
              />

                </Flex>
                <Flex w="100%" as="label" flexDir="column" gap="10px">
                  <Text fontWeight="bold">Suspension End Date:</Text>
                  <Input
                    as={Field}
                    size="md"
                    borderColor="#437115y689"
                    placeholder="Choose suspension end Date"
                    name="SuspensionEndDate"
                    type="date-local"
                  />
                </Flex>
                <label style={{ width: '100%' }}>
                  <Box fontWeight="bold">Reason</Box>
                  <Textarea
                    w="100%"
                    borderColor="#437115y689"
                    placeholder="Reason"
                    resize="vertical"
                    size="sm"
                    value={Reason}
                    name="Reason"
                    onChange={(e: any) => set_reason(e.target.value)}
                  />
                </label>
                <Button disabled={isLoading} type="submit" bg="var(--dark-green-color)" color="var(--white-color)">
                  {isLoading ? 'Loading' : 'Submit'}
                </Button>
              </Flex>
            </Form>
          );
        }}
      </Formik>
    );
  };
  
  const Label = styled.label``; 
  
  const TempPopUp = (props:any) =>{
    const index = props.index;
    const data = props.data;
    // console.log(data,'data')
    const [active,set_active] = useAtom(SuspendAtom);
    const [,set_open] = useAtom(openAtom);
    const [,set_modal] = useAtom(modalAtom);
    const [,set_Nopen] = useAtom(openNAtom);
    const [,set_notification]= useAtom(notificationAtom);
  
    const handleClick = () =>{
      if(index === active){
        set_active(null);
        return;
      }
      else{
        set_active(index);
      }
    }
    const handleView= () =>{
      set_modal({
        header:'View suspended student',
        content:<Grid>
          {/* <GridItem justify="space-between" p="10px 0" as={Flex}>
            <span>Id</span>
            <span>{data?.Id}</span>
          </GridItem > */}
          <GridItem justify="space-between" p="10px 0" as={Flex}>
            <Text fontWeight="bold">Student No:</Text>
            <span>{data?.StudentMembershipNo}</span>
          </GridItem >
          <GridItem as={Flex} justify="space-between" p="10px 0">
          <Text fontWeight="bold">Suspension start Date:</Text>
            <span>{format(new Date(data?.SuspensionStartDate), "dd/MM/yyyy")}</span>
          </GridItem>
          <GridItem as={Flex} justify="space-between" p="10px 0">
          <Text fontWeight="bold">Suspension End Date:</Text>
            <span>{format(new Date(data?.SuspendedUntil), "dd/MM/yyyy")}</span>
          </GridItem>
          <GridItem justify="space-between" p="10px 0" as={Flex}>
          <Text fontWeight="bold">Reason:</Text>
            <span>{data?.Reason || 'N/A'}</span>
          </GridItem >
          {/* <GridItem as={Flex} justify="space-between" p="10px 0">
          <Text fontWeight="bold">Suspended Until:</Text>
            <span>{format(new Date(data?.SuspendedUntil), "dd/MM/yyyy")}</span>
          </GridItem> */}
        </Grid>
      })
      set_open(true);
      handleClick();
    }
    const handleEdit = () =>{
      handleClick();
      set_modal({
        header:'Edit Suspension',
        content:<AddType {...data}/>
      });
      set_open(true);
      handleClick();
      
    }
    // const handleDelete = () =>{
    //   set_modal({
    //     header:'Delete Study Center',
    //     content:<Grid gap="20px">
    //       <GridItem>Are you Sure you want to delete this Study Center?</GridItem>
    //       <GridItem as={Flex} justify="space-between" p="20px 0">
    //         <Button disabled={isLoading} onClick={()=>deleteFee()} bg="var(--dark-green-color)"
    //           color="var(--white-color)" >{isLoading?'Loading':'Delete'}</Button>
    //         <Button disabled={isLoading} 
    //           variant="outline" bg="var(--white-color)"
    //           onClick={()=>set_open(false)}
    //           border="1px solid var(--dark-green-color)"
    //           color="var(--dark-green-color)" >Cancel</Button>
    //       </GridItem>
    //     </Grid>
    //   });
    //   set_open(true);
    // }
    
    return (
      <TablePopUp click={handleClick} options={[
        {label:'View Suspend',click:handleView},
        {label:'Edit suspend',click:handleEdit},
        // {label:'Delete Study Center',click:handleDelete}
      ]} />
    )
  }
  
  